import UpdateProject from "./Container"

export default UpdateProject
